/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Ryzyko odejścia; brak gdy nie oceniono.
 * @export
 * @enum {string}
 */

export const TeamEmployeeRiskLevelDto = {
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW'
} as const;

export type TeamEmployeeRiskLevelDto = typeof TeamEmployeeRiskLevelDto[keyof typeof TeamEmployeeRiskLevelDto];



